import { computePosition, autoUpdate, offset, flip } from '@floating-ui/dom';

export default (content) => {
    return (inputOptions) => ({
        ...content(inputOptions),

        get dates() {
            return [...this.previousDates, ...this.currentDates, ...this.nextDates];
        },

        initPositioningSystem() {
            this.$refs.popover.style.position = 'fixed';
            this.$refs.popover.style.visibility = 'hidden';
            this.$refs.popover.style.width = '18rem';
            this.$refs.popover.style.bottom = 'auto';
            this.$refs.popover.style.right = 'auto';

            this.$watch('popover', (state) => {
                if (!state && this.cleanupPosition) {
                    this.cleanupPosition();
                    this.cleanupPosition = null;
                }

                if (state) {
                    this.$refs.popover.style.visibility = 'hidden';
                }

                if (state && !this.cleanupPosition) {
                    this.refreshPopover();
                }
            });
        },

        updatePosition() {
            computePosition(this.$root, this.$refs.popover, {
                placement: 'bottom',
                middleware: [offset(4), flip()],
                strategy: 'fixed',
            }).then(({ x, y }) => {
                Object.assign(this.$refs.popover.style, {
                    position: 'fixed',
                    left: `${x}px`,
                    top: `${y}px`,
                    bottom: 'auto',
                    right: 'auto',
                    width: '18rem',
                });

                setTimeout(() => {
                    this.$refs.popover.style.visibility = 'visible';
                }, 100);
            });
        },

        refreshPopover() {
            this.$nextTick(() => {
                this._waitUntilStable(() => {
                    this.syncPopoverPosition();
                });
            });
        },

        _waitUntilStable(callback) {
            let lastRect = this.$root.getBoundingClientRect();

            const check = () => {
                const rect = this.$root.getBoundingClientRect();

                if (rect.left === lastRect.left && rect.top === lastRect.top) {
                    callback();
                } else {
                    lastRect = rect;
                    requestAnimationFrame(check);
                }
            };

            requestAnimationFrame(check);
        },

        syncPopoverPosition() {
            this.cleanupPosition = autoUpdate(
                this.$root,
                this.$refs.popover,
                () => this.updatePosition(),
                { ancestorResize: true, ancestorScroll: true, elementResize: true },
            );
        },
    });
};
